import { Injectable } from '@angular/core';
import { applyReclassificationsToFinStatements } from '@modeso/aumico-lib-annualreport-fe/helpers/applyReclassificationsToFinStatements';
import { IAnnualReport } from '@modeso/types__aumico-lib-annualreport-be';
import { IFxNotesPrintEngine, IFxSuperTablePrintContext } from '@modeso/aumico-lib-notes-fe';
import { I18NextService } from 'angular-i18next';
import { cloneDeep } from 'lodash-es';
import { FxTranslationHelper } from '../utils/FxTranslationHelper';

/**
 * FX (REV-21512): app-side adapter behind the lib's FX_NOTES_PRINT_ENGINE token — the notes
 * display components self-serve their FX bundle from it (reclass pattern), while the engine
 * itself (FxTranslationHelper on the GroupingHelper stack) stays in the app. Registered in
 * app.module; libs and other apps without the provider simply render without FX (G0).
 */
@Injectable()
export class FxNotesPrintEngineService implements IFxNotesPrintEngine {
    constructor(private readonly i18next: I18NextService) {}

    buildSuperTablePrintFx(annualReport: IAnnualReport): IFxSuperTablePrintContext | null {
        // The engine's contract wants reclass-materialized statements (the print page's own AR
        // stream is raw) — otherwise the twins would contradict the printed functional columns.
        const finStatements = annualReport?.finStatements?.map((fs) => cloneDeep(fs));
        if (finStatements != null) {
            applyReclassificationsToFinStatements(finStatements, annualReport.groupingAndMasking);
        }

        return FxTranslationHelper.buildSuperTablePrintFx(
            annualReport,
            finStatements,
            this.i18next.t('aumico_annual_report_fx_notes_reserve_label') as string,
        );
    }
}
